import React, { Component } from 'react';
import { connect } from 'react-redux';
import './DetailsSchedule.css';
import {
  getCurrentWorkOrder,
  getTasks,
} from 'selectors/admin/work-orders/work-orders';
import { getQuotes } from 'selectors/admin/work-orders/details/details';
import { taskScheduleUpdate } from 'actions/admin/work-orders/details/details';
import {
  getOpenItemsByTaskId,
  getSelectedOpenItemId,
} from 'selectors/admin/work-orders/details/details';
import EditOpenItemModal from 'components/admin/work-orders/details/open-items/EditOpenItemModal';
import {
  setSelectedOpenItem,
  updateWorkOrderSchedule,
} from 'actions/admin/work-orders/details/details';
import Gantt from './Gantt';

class DetailsSchedule extends Component {
  render() {
    return (
      <div className="details-schedule">
        <Gantt
          workOrder={this.props.workOrder}
          tasks={this.props.tasks}
          quotes={this.props.quotes}
          openItems={this.mapOpenItems()}
          onWorkOrderUpdate={this.handleScheduleUpdateWorkOrder}
          onTaskUpdate={this.handleScheduleUpdateTask}
          onOpenItemClick={this.handleOpenItemSelection}
        />

        {this.props.selectedOpenItemId !== null && (
          <EditOpenItemModal
            taskId={this.taskId}
            taskNumber={this.taskNumber}
          />
        )}
      </div>
    );
  }

  handleScheduleUpdateWorkOrder = (workOrderId, start, end) => {
    this.props.dispatch(updateWorkOrderSchedule(workOrderId, start, end));
  };

  handleScheduleUpdateTask = (taskId, start, end) => {
    this.props.dispatch(taskScheduleUpdate(taskId, start, end));
  };

  mapOpenItems = () => {
    let openItems = Object.values(this.props.openItems).reduce(
      (accumulator, currentValue) => accumulator.concat(currentValue),
      []
    );
    return openItems;
  };

  handleOpenItemSelection = (openItemId) => {
    const openItem = this.mapOpenItems().find(
      (openItem) => openItem.id === openItemId
    );
    this.taskId = openItem.task.id;
    this.taskNumber = openItem.task.number;
    this.props.dispatch(setSelectedOpenItem(openItem));
  };
}

export default connect((state) => {
  return {
    workOrder: getCurrentWorkOrder(state),
    tasks: getTasks(state),
    quotes: getQuotes(state),
    openItems: getOpenItemsByTaskId(state),
    selectedOpenItemId: getSelectedOpenItemId(state),
  };
})(DetailsSchedule);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/schedule/DetailsSchedule.js